import { SetStateAction, useEffect, useState } from "react";
import { GridMetaData } from "models/grids";
import { useCurrentUser, useCentralApi } from "hooks/shared";
import { IWorkItemSearchStatuses} from "hooks/work-items/useWorkItemPossibleStatus"; 

export interface GetWorkItemResult {
    workItems: WorkItem[]
    responsibilities: Responsibility[]
}

export interface WorkItem {
    workItemInstanceId: number
    parentWorkItemInstanceId?: number
    treePath: string
    treeLevel: number
    workItemInstanceName: string
    workItemTemplateId: number
    workItemTemplateName: string
    workspaceInstanceId: number
    workspaceInstanceName: string
    workItemStatusId: number
    versionStamp: string
    selected: boolean
    error: boolean
    errorMessage: any
    selectedResponsibility: any
    isDirty: boolean
    parentTreePath: string
    contentTypeId?: number
    contentTypeName?: string
    originalSelectedValue? : number
}

export interface Responsibility {
    workItemResourcesId: number
    workItemInstanceId: number
    userId: string
    firstName: string
    lastName: string
    responsibilityId: number
    responsibilityName: string
    sequence: number
    isDefaultAssignee: boolean
    versionStamp: string
    fullName: string
}

type WorkItemResult = [
    GetWorkItemResult | null,
    boolean,
    string | null,
    React.Dispatch<SetStateAction<GetWorkItemResult | null>>
];

export interface WorkItemSearchCriteria {
    workItemSearchText: string;
    includeChildWorkItems: boolean;
    status: number[];
    workspaces: number[];
    resource: string;
    resourceOnlyAsPrimary: boolean;
    contentType: number[];
    userId: string;
    searchAll: boolean;
    responsibilities: number[];
    responsibilityUseOrOperator: boolean;
    matchOnPrimary: boolean;
    hash?: number;
}

const useWorkItems: (searchCriteria: WorkItemSearchCriteria, gridMetadata: GridMetaData, doSearch: boolean, setDoSearch: React.Dispatch<SetStateAction<boolean>>,WorkItemSearchStatuses:IWorkItemSearchStatuses[]) => WorkItemResult = (searchCriteria, gridMetadata, doSearch, setDoSearch,WorkItemSearchStatuses) => {
    const [ result, setResult ] = useState<GetWorkItemResult | null>(null);
    const [ error, setError ] = useState<string | null>(null);
    const [ loading, setLoading ] = useState<boolean>(true);
    const user = useCurrentUser();
    const fetcher = useCentralApi(user);

    useEffect(() => {        
        const controller = new AbortController();
        const fetchTasks = async () => {            
            if (user && user.id_token && doSearch) {
                setLoading(true);
                setResult(null);
                try {
                    searchCriteria.status = searchCriteria?.status?.length > 0 ? searchCriteria.status : WorkItemSearchStatuses.map(status => +status.id);
                    const resp = await fetcher(`/api/v3/bulkupdate/workitem/SearchWorkItems`, {
                        method: 'POST',
                        body: JSON.stringify(searchCriteria),
                        signal: controller.signal
                    });

                    if (!resp.ok) {
                        // RESPOND TO ERRORS
                    }

                    const data = await resp.json();
                    setResult(data);

                } catch (err) {
                    // TODO: 
                } finally {
                    setLoading(false);
                    if (doSearch)
                        setDoSearch(false);
                }
            } 
            else if (result === null && !doSearch) {
                setLoading(true);
                setResult({
                    workItems: [],
                    responsibilities: []
                });
                setLoading(false);
            }
        };
        fetchTasks()
        .catch((err) => {});

        return () => {
            if (!doSearch) {
                controller.abort();
                setLoading(false);
            }
        };
    }, [ doSearch, WorkItemSearchStatuses]);

    return [
        result,
        loading,
        error,
        setResult
    ];
};

export default useWorkItems;